"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const jlDataUtils_1 = require("../../utils/jlDataUtils");
const kevelVisibility_1 = require("../../utils/kevelVisibility");
const isValidKevelEvent = (event) => {
    return Boolean(event.adId && event.type && event.clickUrl && event.impressionUrl);
};
const getMatchingEvent = (element, validEvents) => validEvents.find((eventData) => element.getAttribute("data-kevel-banner-ad-id") === eventData.adId);
const KevelAnalytics = ({ events = [], browserCacheEnabled = false, }) => {
    (0, react_1.useEffect)(() => {
        var _a;
        const validEvents = events.filter(isValidKevelEvent);
        if (validEvents.length === 0) {
            return;
        }
        if (browserCacheEnabled) {
            const renderTimestamp = (_a = document
                .querySelector('meta[name="esi-render-time"]')) === null || _a === void 0 ? void 0 : _a.getAttribute("content");
            const isCached = renderTimestamp
                ? Date.now() - parseInt(renderTimestamp) > 5000
                : false;
            if (isCached) {
                return;
            }
        }
        (0, jlDataUtils_1.addKevelBannersToJlData)(validEvents);
        const observedElements = validEvents.flatMap((eventData) => {
            const elements = Array.from(document.querySelectorAll(`[data-kevel-banner-ad-id="${eventData.adId}"]`));
            if (elements.length === 0) {
                return [];
            }
            return elements;
        });
        observedElements.forEach((element) => {
            const matchingEvent = getMatchingEvent(element, validEvents);
            if (matchingEvent) {
                (0, kevelVisibility_1.observeKevelBanner)(element, matchingEvent);
            }
        });
        return () => {
            const adIds = validEvents.map((event) => event.adId);
            (0, jlDataUtils_1.removeKevelBannersFromJlDataByAdIds)(adIds);
            observedElements.forEach((element) => {
                const matchingEvent = getMatchingEvent(element, validEvents);
                if (matchingEvent) {
                    (0, kevelVisibility_1.unobserveKevelBanner)(element, matchingEvent);
                }
            });
        };
    }, [events, browserCacheEnabled]);
    return null;
};
exports.default = KevelAnalytics;
